import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface State {
  showSaveAllSchedule: { id: string; show: boolean }[];
}

interface Store {
  state: State;
  setShowSaveAllShedule: (payload: { id: string; show: boolean }[]) => void;
}

const initState: State = {
  showSaveAllSchedule: [],
};

export const useScheduleStore = create(
  immer<Store>((set) => ({
    state: initState,
    setShowSaveAllShedule: (payload: { id: string; show: boolean }[]) => {
      set((store) => {
        store.state.showSaveAllSchedule = payload;
      });
    },
  })),
);

export const { setShowSaveAllShedule } = useScheduleStore.getState();

export const showSaveAllScheduleSelector = (s: Store) => s.state.showSaveAllSchedule;
